module.exports = __webpack_public_path__ + "img/edulab-icon.4dfa5360.png";